export enum ErrorMessageCodeEnum {
  i000 = 'I-000', // default
  i001 = 'I-001', // Inloggning
  i002 = 'I-002', // operation fail
  i003 = 'I-003' // wrong horse combination number fence
}
